import type { ReactNode } from 'react';

/** Page header row (title + subtitle + optional right-aligned action) shared by Charter pages. */
export function CharterHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-center justify-between mb-6 gap-4">
      <div>
        <h1 className="text-[23px] font-bold text-foreground">{title}</h1>
        {subtitle && <p className="text-[14px] text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const BOX = 'text-center py-16 text-[14px] border border-dashed border-[#D9D9D9] rounded-[16px]';

export function SelectMerchantPrompt({ what = 'this section' }: { what?: string }) {
  return <div className={`${BOX} text-muted-foreground`}>Select a merchant to manage {what}.</div>;
}

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return <div className="text-center py-16 text-muted-foreground">{label}</div>;
}

export function ErrorState({ label = 'Failed to load. Please try again.' }: { label?: string }) {
  return <div className="text-center py-16 text-red-500">{label}</div>;
}

export function EmptyState({ label }: { label: string }) {
  return <div className={`${BOX} text-muted-foreground`}>{label}</div>;
}

/** Standard bordered table wrapper (horizontal scroll on narrow widths). */
export function TableCard({ children }: { children: ReactNode }) {
  return <div className="bg-card rounded-2xl border border-border overflow-x-auto">{children}</div>;
}

export const TH = 'px-6 py-3 text-xs font-medium text-muted-foreground uppercase tracking-wide';
export const TD = 'px-6 py-4 text-sm text-foreground';
export const TD_MUTED = 'px-6 py-4 text-sm text-muted-foreground';
